import type { ReactNode } from "react";

import { Alert, Button } from "@/atoms";
import { AlertVariantEnum } from "@/enums";

import { AuthHeader } from "./auth-header";

export const AuthSuccessState = ({
    actionLabel,
    isFullWidth = false,
    message,
    onAction,
    title,
    variant = "primary",
}: {
    actionLabel: string,
    isFullWidth?: boolean,
    message: ReactNode,
    onAction: () => void,
    title: string,
    variant?: "link" | "primary",
}) => (
    <div>
        <AuthHeader title={title} />
        <Alert
            className="mb-6"
            variant={AlertVariantEnum.SUCCESS}
        >{message}</Alert>
        <Button
            isFullWidth={isFullWidth}
            variant={variant}
            onClick={onAction}
        >
            {actionLabel}
        </Button>
    </div>
);
